import React, { Suspense } from 'react';
import { AuthErrorBoundary } from './AuthErrorBoundary';
import { AuthProvider } from '@/hooks/useAuth';
import { Skeleton } from '@/components/ui/skeleton';

const LoadingFallback = () => (
  <div className="min-h-screen bg-background">
    <div className="container mx-auto p-8 space-y-8">
      <Skeleton className="h-8 w-48" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} className="h-32" />
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Skeleton className="h-96" />
        </div>
        <Skeleton className="h-96" />
      </div>
    </div>
  </div>
);

interface SafeAuthProviderProps {
  children: React.ReactNode;
}

export const SafeAuthProvider = ({ children }: SafeAuthProviderProps) => {
  try {
    return (
      <AuthErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <AuthProvider>
            {children}
          </AuthProvider>
        </Suspense>
      </AuthErrorBoundary>
    );
  } catch (error) {
    console.error('SafeAuthProvider error:', error);
    return <div>Authentication system unavailable</div>;
  }
};